/* The same reveal control works in the storefront and Shopify section editor. */
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-cs-events-list]').forEach(section => {
      if (section.dataset.eventsWorldReady) return;
      section.dataset.eventsWorldReady = 'true';
      const button = section.querySelector('[data-load-more]');
      if (!button) return;
      const hidden = () => [...section.querySelectorAll('[data-events-item].is-hidden')];
      button.addEventListener('click', () => {
        const items = hidden().slice(0, Number(button.dataset.step) || 8);
        items.forEach(item => item.classList.remove('is-hidden'));
        if (items[0]) {
          const link = items[0].querySelector('a');
          if (link) link.focus({preventScroll: true});
        }
        if (!hidden().length) button.hidden = true;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
